<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { interactionMixin } from "src/modules/interactions_module.js";
import { KenwoodItaly } from '../../modules/kenwood_italy_module.js';
import { get } from "lodash";

export default {
  mixins: [fandomBasicMixin, interactionMixin],
  props: {},
  mounted() {},
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl,
  },
  computed: {
    owner() {
      return (Fandom.exists(this.content.owned_by) && this.pageModel.id_to_user[this.content.owned_by]) ? this.pageModel.id_to_user[this.content.owned_by] : null;
    },
    voteInteraction() {
      return (this.content.interactions && this.content.interactions["vote"]) ? this.content.interactions["vote"] : false;
    },
    userHasVoted() {
      return this.voteInteraction ? (this.isInteractionDone(this.containerContent, this.content.interactions["vote"].interaction) ? true : false ) : false;
    },
    numberOfVotes() {
      let numberOfVotes = 0;
      if(this.voteInteraction) {
        const contentUserInfo = this.getContentUserInfo(this.containerContent);
        numberOfVotes = get(contentUserInfo, ["id_to_interaction", this.content.interactions["vote"]["interaction"].id, "votes_info", "number_of_votes"], 0);
      }
      return numberOfVotes;
    },
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :id="`ref-${easyadminId}`" :class="contentType" class="w-100" tile-ugc-video-contest>
    <div class="tile-ugc-video-contest__content d-flex flex-column">
      <div class="tile-ugc-video-contest__img-wrapper w-100">
        <a :id="`ref-${easyadminId}-link`" :href="content.slug">
          <div class="tile-ugc-video-contest__img-content bg w-100 lazy-bg" :lazy-src="getTileThumbnailUrl('thumbnail')">
            <div v-if="voteInteraction" class="tile-ugc-video-contest__votes-counter px-2 bg-cheddar position-absolute d-flex align-items-center justify-content-center">
              <div class="counter-number pr-1">{{numberOfVotes}}</div>
              <svg id="star-icon"><use :xlink:href="userHasVoted ? '#star' : '#star-o'"></use></svg>
            </div>
            <div class="tile-ugc-video-contest__play-icon-container d-flex align-items-center justify-content-center position-absolute">
              <svg id="play-icon"><use xlink:href="#play"></use></svg>
            </div>
          </div>
        </a>
        <div v-if="owner" class="user-info-content d-flex">
          <div class="user-info-content__name align-items-center d-flex text-kenwood-dark-grey">By {{owner.username}}</div>
          <div v-if="owner.avatar" class="user-info-content__avatar-container">
            <div class="user-info-content__avatar" :style="{'background-image': getBackgroundUrl(owner.avatar.url)}"></div>
          </div>
        </div>
      </div>
      <div class="tile-ugc-video-contest__info-wrapper w-100">
        <div class="tile-ugc-video-contest__info-content w-100 d-flex justify-content-between">
          <div class="interactions-box-wrapper d-flex w-100">
            <div class="interactions-box-content d-flex w-100">
              <template v-if="voteInteraction">
                <button v-if="!userHasVoted" role="button " class="btn btn-cheddar w-100 px-3"
                  @click="updateVoteInteraction(containerContent, voteInteraction, voteInteraction.interaction, 1,)">
                  {{ft("vote.vote")}}
                </button>
                <button v-else role="button " class="btn btn-kenwood-light-grey w-100 px-3">{{ft("vote.thanks")}}</button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[tile-ugc-video-contest] {
  padding-bottom: 85.5%;

  svg#play-icon {
    stroke: $white;
    width: 3.8rem;
    height: 3.8rem;
  }

  svg#star-icon{
    stroke: $black;
    width: 1.1rem;
    height: 1.1rem;
  }

  .tile-ugc-video-contest__play-icon-container {
    height: 84%;
    width: 100%;
    right: 0;
    left: 0;
    top: 0;
  }

  .tile-ugc-video-contest__votes-counter {
    height: 2rem;
    min-width: 4rem;
    border-radius: 1rem;
    top: 0.75rem;
    right: 0.5rem;

    .counter-number {
      padding-top: 3px;
      color: $black;
    }
  }

  // Sum of these classes 'padding-bottom' property must be equal to 120% (because of fixed aspect-ratio)
  .tile-ugc-video-contest__img-wrapper {
    padding-bottom: 67.4%;
  }

  .tile-ugc-video-contest__info-wrapper {
    padding-bottom: 16.1%;

  }

  .interactions-like, .interactions-favourite {
    color: $kenwood-dark-grey;
    i {
      cursor: pointer;
      &:hover {
        color: $red-cabbage;
      }
    }
  }

  .interactions-like {
    span {
      font-size: 0.8rem;
    }
  }

  .user-info-content__name {
    font-size: 0.8125rem;
    overflow: hidden;
    position: relative;
    width: 74%;
  }

  .user-info-content__avatar-container {
    position: relative;
    width: 26%;
  }

  .user-info-content__avatar {
    background-position: center;
    background-size: cover;
    border-radius: 50%;
    bottom: 25%;
    padding-bottom: 64%;
    position: absolute;
    right: 10%;
    width: 64%;
  }

  .interactions-box-content {
    font-size: 1.35rem;
  }

  .tile-ugc-video-contest__content,
  .tile-ugc-video-contest__info-content, .tile-ugc-video-contest__img-content {
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .tile-ugc-video-contest__img-wrapper, .tile-ugc-video-contest__info-wrapper {
    position: relative;
    overflow: hidden;
  }

  .tile-ugc-video-contest__img-content {
    background-size: cover;
    cursor: pointer;
    background-position: center;
    background-color: $kenwood-light-grey;
  }

  .user-info-content {
    position: absolute;
    width: 100%;
    height: 16%;
    background-color: $white;
    bottom: 0;
    left: 0;
  }

}
</style>
